import React, { useState } from 'react'

import PropTypes from 'prop-types'

import AppSwiper from 'Components/AppSwiper'

import { _SwiperWrapper } from './styles'


const swiperOptions = {
  effect: 'slide',
  spaceBetween: 0,
  // slidesPerView: 'auto',
  slidesToScroll: 'auto',
  loop: false,
  freeMode: true,
  // lazy: true,
  navigation: true,
}


const TileSlider = ({
  freeMode = true,
  children,
  extraOptions = {},
  hideNextPrev = false,
  // renderPrevButton,
  // renderNextButton,
  // shouldSwiperUpdate = false,
  // setRef = () => {},
  nearbyListingsOrSimilarListings,
}) => {
  const [sliderStatus, setSliderStatus] = useState({
    canScrollNext: false,
    canScrollPrev: false,
  })

  const onSlideChange = data => {
    setSliderStatus(data)
  }

  return (
    <_SwiperWrapper
      hideNextPrev={hideNextPrev}
      nearbyListingsOrSimilarListings={nearbyListingsOrSimilarListings}
      canScrollNext={sliderStatus.canScrollNext}
      canScrollPrev={sliderStatus.canScrollPrev}
    >
      <AppSwiper
        swiperOptions={{
          ...swiperOptions,
          ...extraOptions,
          dragFree: freeMode,
        }}
        onSlideChange={onSlideChange}
      >
        {children}
      </AppSwiper>
    </_SwiperWrapper>
  )
}


TileSlider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node]),
  freeMode: PropTypes.bool,
  hideNextPrev: PropTypes.bool,
  // Pass true if slider content is dynamic
  // shouldSwiperUpdate: PropTypes.bool,
  extraOptions: PropTypes.shape({}),
  // renderPrevButton: PropTypes.func,
  // renderNextButton: PropTypes.func,
  // setRef: PropTypes.func,
  nearbyListingsOrSimilarListings: PropTypes.bool,
}

export default TileSlider
